import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=14f0f3d7&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=ts"
export * from "./CustomerForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=14f0f3d7&prod&lang=scss&scoped=true"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=14f0f3d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f0f3d7",
  null
  
)

export default component.exports